module.exports = __webpack_public_path__ + "img/1724248786579-IMG_1531.png.50795acd.webp";